<h1 matDialogTitle>{{data.title}}</h1>
{{"ADD" | translate }} {{"MEMBER" | translate }}
  <form [formGroup]="itemForm" (ngSubmit)="submit()">
  <div fxLayout="row wrap" fxLayout.lt-sm="column">
    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        name="username"
        [formControl]="itemForm.controls['name']"
        placeholder="Name">
      </mat-form-field>
    </div>

    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        type="number"
        name="age"
        [formControl]="itemForm.controls['age']"
        placeholder="Age">
      </mat-form-field>
    </div>

    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        type="email"
        name="email"
        [formControl]="itemForm.controls['email']"
        placeholder="Email">
      </mat-form-field>
    </div>

    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        name="company"
        [formControl]="itemForm.controls['company']"
        placeholder="Company">
      </mat-form-field>
    </div>
    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        name="phone"
        [formControl]="itemForm.controls['phone']"
        placeholder="Phone">
      </mat-form-field>
    </div>
    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        name="address"
        [formControl]="itemForm.controls['address']"
        placeholder="address">
      </mat-form-field>
    </div>
    <div fxFlex="50"  class="pr-1">
      <mat-form-field class="full-width">
        <input
        matInput
        name="balance"
        [formControl]="itemForm.controls['balance']"
        placeholder="Balance">
      </mat-form-field>
    </div>
    <div fxFlex="50"  class="pt-1 pr-1">
      <mat-slide-toggle [formControl]="itemForm.controls['isActive']">Active Customer</mat-slide-toggle>
    </div>

    <div fxFlex="100" class="mt-1">
      <button mat-raised-button color="primary" [disabled]="itemForm.invalid">{{"SAVE" | translate }}</button>
      <span fxFlex></span>
      <button mat-button color="warn" type="button" (click)="dialogRef.close(false)">Cancel</button>
    </div>
  </div>
  </form>